import Text from "lib/components/Text"
import consola from "consola"
import { forwardRef } from "react"

interface OptionRadio {
  value: string;
  label: React.ReactNode;
}

export interface RadioProps {
  onChange?: (object) => void;
  error?: boolean;
  options: OptionRadio[];
  name: string;
  label?: string;
  value: string;
  message?: string;
  isHorizontal?: boolean
  isHorizontalChild?: boolean
  labelColor?: "gray" | "dark"
  disabled?: boolean
  size?: "small" | "default" | "medium" | "large"
}

const Radio = forwardRef<HTMLInputElement, RadioProps>(({
  onChange = () => { consola.info("on change not set!")}, 
  error, 
  label, 
  options, 
  name, 
  message, 
  isHorizontal = false, 
  isHorizontalChild = false, 
  value, 
  labelColor = "gray", 
  disabled = false,
  size = "large",
}: RadioProps, radioRef) => {
  Radio.displayName = "Radio"

  let radioColor = "text-neutral-40"
  let scaleSize = "scale-150"
  const labelStyle = "mb-2"
  let labelValue = <div />

  if (error) {
    radioColor = "text-danger"
  }

  if (label) {
    if (label.includes("*")) {
      labelValue = (
        <div className="flex gap-x-1">
          <Text type="small-body" color={labelColor}>
            {label.replace(" *", "")}
          </Text>
          <Text weight="bold" type="small-body" color="danger">
            *
          </Text>
        </div>
      )
    } else {
      labelValue = (
        <Text type="small-body" color={labelColor}>
          {label}
        </Text>
      )
    }
  }

  switch (size) {
    case "small":
      scaleSize = "scale-90"
      break
    case "default":
      scaleSize = "scale-100"
      break
    case "medium":
      scaleSize = "scale-125"
      break
    default:
      break
  }

  return (
    <div>

      {label && (
        <div className={labelStyle}>
          {labelValue}
        </div>
      )}
      <div className={`flex ${isHorizontal ? "mt-3.5 flex-row gap-x-6 sm:gap-x-8" : "mt-2 flex-col gap-y-2"}`}>
        {options.map((radio, indexRadio) => (
          <div key={indexRadio} className={`flex ${isHorizontalChild ? "flex-row gap-y-2 gap-x-3" : "flex-col gap-x-3 gap-y-2"} items-center`}>
            <input
              className={`${radioColor} ${scaleSize}`}
              type="radio"
              name={name}
              value={radio.value}
              onChange={(event) => onChange(event)}
              ref={radioRef}
              checked={radio.value === value}
              disabled={disabled}
            />
            {radio.label && (
              <div role="button" tabIndex={0} className="flex flex-col" onClick={() => {
                onChange({target: {value: radio.value}})
                }}>
                {radio.label}
              </div>
            )}
          </div>
        ))}
      </div>
      {error && (
        <div className="mt-1">
          <Text type="small-body" color="danger">
            {message}
          </Text>
        </div>
      )}
    </div>
  )
})

export default Radio